import { render, staticRenderFns } from "./Tetris.container.vue?vue&type=template&id=080d28c7&scoped=true&"
import script from "./Tetris.container.vue?vue&type=script&lang=js&"
export * from "./Tetris.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d28c7",
  null
  
)

export default component.exports